import React from 'react'

import { StyledSearch, StyledSearchListings } from './search-listings.styles'
import { SkeletonSearchListing } from '../search-listing/search-listing.skeleton'
import { StyledSearchLI, StyledSearchUl } from './search-ul.styles'
import { useObserveScreenWidth } from '../../hooks/use-observe-screen-width.hook'

export const StyledSearchUlSkeleton = () => {
    const { isMobile } = useObserveScreenWidth()
    const numberOfListings = !isMobile ? 10 : 3

    return (
        <StyledSearchUl>
            {Array.from(Array(numberOfListings).keys())?.map((i: number) => {
                return (
                    <StyledSearchLI className={'skeleton'} key={`skeletonListing${i}`}>
                        <SkeletonSearchListing index={i} />
                    </StyledSearchLI>
                )
            })}
        </StyledSearchUl>
    )
}

export const SkeletonSearchListings = () => {
    return (
        <StyledSearchListings data-testid="search">
            <StyledSearch>
                <StyledSearchUlSkeleton />
            </StyledSearch>
        </StyledSearchListings>
    )
}
